// third party
import * as yup from 'yup';

// project imports
import { validationSchema as execSettingsValidationSchema } from 'store/app/workmgmt/exec-settings';
import { validationSchema as noteValidationSchema } from 'store/app/workmgmt/note';

const validationSchema = (intl) =>
    yup.object().shape({
        name: yup
            .string()
            .max(255, intl.formatMessage({ id: 'ui-comp-formvalidation-name-max', values: { maxValue: 255 } }))
            .required(intl.formatMessage({ id: 'ui-comp-formvalidation-name-required' })),
        description: yup.string().nullable(),
        department: yup
            .object()
            .shape({})
            .nullable()
            .required(intl.formatMessage({ id: 'ui-comp-formvalidation-department-required' })),
        client: yup.object().shape({}).nullable(),
        priority: yup.string().nullable(),
        responsible: yup
            .object()
            .shape({})
            .nullable()
            .required(intl.formatMessage({ id: 'ui-comp-formvalidation-responsible-required' })),
        participants: yup.array(yup.object().shape({}).nullable()).nullable(),
        execSettings: execSettingsValidationSchema(intl),
        taskHierarchyEnabled: yup.boolean().nullable(),
        notes: yup.array().of(noteValidationSchema(intl)).nullable(),
        tasks: yup.array().of(yup.object().shape({}).nullable()).nullable(),
        files: yup.array().of(yup.object().shape({}).nullable()).nullable(),
        tempFoldersName: yup.string().nullable()
    });

export default validationSchema;
